<ng-template #avatarTemplate let-user="user">
  <span text-default> {{ translations.referralQuestions!.referredBy | translate }} </span>

  @if (!user || user.anonymizedAt) {
    <rt-avatar
      [type]="'icon'"
      [size]="'small-x'"
      [shape]="'oval'"
      context="admin"
      iconName="person"
      margin-left-small-x
      margin-right-small-xx
    ></rt-avatar>
    {{ translations.referralQuestions!.deletedReferrer | translate }}
  }

  @if (user && !user.anonymizedAt) {
    <rt-avatar
      [type]="user.hasAvatar ? 'image' : 'initials'"
      [size]="'small-x'"
      [shape]="'oval'"
      [imageSrc]="user.avatarThumbUrl"
      [initials]="user.initials"
      [fontSize]="'small'"
      margin-left-small-x
      margin-right-small-xx
    ></rt-avatar>
    {{ user.firstName }} {{ user.lastName }}
  }

  <span text-default margin-lr-small-xx>
    {{ translations.referralQuestions!.for | translate }}
  </span>
</ng-template>

<ng-template #collapseIconTemplate let-collapsed="collapsed">
  @if (collapsed === CollapseState.Normal) {
    <rt-icon colorToken="colorIconLowDefault" name="keyboard-arrow-up"> </rt-icon>
  }

  @if (collapsed === CollapseState.Collapsed) {
    <rt-icon colorToken="colorIconLowDefault" name="keyboard-arrow-down"> </rt-icon>
  }
</ng-template>

@for (group of groups; track groupsTrackBy(index, group); let index = $index; let last = $last) {
  <div class="group">
    @if (hasTitleGroup(group) && group.question.openQuestionAnswers.length > 0) {
      <div
        (click)="handleGroupClick(group)"
        [class.can-collapsed]="canCollapsed(group)"
        [class.is-expanded]="group.collapsed === CollapseState.Normal"
        class="header"
        padding
      >
        <div class="title">
          <!-- Status is visible for grouped open questions -->
          @if (!!group.decoratedStatus) {
            <rt-offer-status-indicator
              [offerStatus]="{ status: group.decoratedStatus, kind: 'job' }"
            ></rt-offer-status-indicator>
          }

          <!-- Avatar is visible for referrals, user has null value or has anonymizedAt attribute when was deleted -->
          @if (mode === QuestionsMode.ReferralQuestions) {
            <div class="avatar">
              <ng-container
                *ngTemplateOutlet="avatarTemplate; context: { user: group.question.user }"
              ></ng-container>
            </div>
          }

          {{ getGroupTitle(group) }}

          @if (canCollapsed(group)) {
            <div class="icon">
              <ng-container
                *ngTemplateOutlet="collapseIconTemplate; context: { collapsed: group.collapsed }"
              ></ng-container>
            </div>
          }
        </div>

        <div class="date">
          <rt-date [time]="group.question.updatedAt! || group.question.createdAt!" variant="small">
          </rt-date>
        </div>
      </div>
    }

    @if (!canCollapsed(group) || group.collapsed === CollapseState.Normal) {
      <div class="content">
        @for (answer of group.question.openQuestionAnswers; track answersTrackBy($index, answer)) {
          <rt-candidate-questions-item
            [canManageCandidates]="canManageCandidates"
            [data]="$any(answer)"
            [visibilityTplRef]="visibilityTplRef"
            [hasBooleanFlagAnswers]="hasBooleanFlagAnswers"
          ></rt-candidate-questions-item>
        }
      </div>
    }

    @if (!last) {
      <rt-divider></rt-divider>
    }
  </div>
}
